
import { useMemo } from 'react';
import { foremanDB } from '../../types/IndexedDB/ForemanDB';
import { JobRoleEnum } from '../../types/Employee/JobRole';
import { useTokenClaims } from '../../security/useTokenClaims';
import { ForemanDB } from '../../types/IndexedDB/ForemanDB';

export function useIndexedDB() : ForemanDB | null {
  const { role } = useTokenClaims();
  const db = useMemo(() => {
    switch (role.title) {
      case 'Foreman':
        return foremanDB;
      default:
        return null;
    }
  }, [role]);
  

  return db;
}
